import { createFileRoute } from '@tanstack/react-router'
import LinkDetailVideoStatsContainer from '../components/LinkDetailVideoStatsContainer'

export const Route = createFileRoute('/link-detail/$linkId/video-stats')({
  component: RouteComponent,
})

function RouteComponent() {
  const { linkId } = Route.useParams()

  return (
    <div>
      <LinkDetailVideoStatsContainer linkId={linkId} />
    </div>
  )
}
